import React from 'react'
import Check from '../../public/images/icons/check.svg'
import CheckError from '../../public/images/icons/checkError.svg'

import { Product } from '@/src/types/api-types'
import getProductAvailable from '@/lib/getProductAvailable'
import { useStyleProductResume } from '@/components/Product/ProductResume'
import clsx from 'clsx'

type Props = {
  product: Product
  displayDateAvailable?: boolean
  className?: string
}

const ProductAvailble: React.FC<Props> = ({ product, displayDateAvailable = false, className }) => {
  const classesResume = useStyleProductResume({})

  const isProductAvailable: boolean = getProductAvailable(product)

  return (
    <div className={clsx(classesResume.rootInfoProduct, className)}>
      <div className={classesResume.svgInfoProduct}>
        {!isProductAvailable ? (
          <CheckError width={20} height={20} />
        ) : (
          <Check width={20} height={20} />
        )}
      </div>
      <span
        className={classesResume.infoProduct}
        style={isProductAvailable ? {} : { color: 'red' }}
      >
        {t({
          id: isProductAvailable
            ? 'web_en_stock'
            : displayDateAvailable
              ? 'web_indisponible_stock_list'
              : 'web_indisponible_pour_le_moment',
        })}
      </span>
    </div>
  )
}

export default ProductAvailble
